export class AccountInfoNewRelicAttributes {
  constructor(subscribeFn) {
    this.accountNo = null;
    this.subscribeFn = subscribeFn;
    this.subscribeToAccountInfo();
  }

  getAccountNo() {
    return this.accountNo;
  }

  setAccountNo(accountNo) {
    this.accountNo = accountNo;
  }

  subscribeToAccountInfo() {
    try {
      if (typeof this.subscribeFn !== 'function') {
        return;
      }

      this.subscribeFn({
        topic: 'wh.common.event.account.info.state.changed',
        callback: (payload) => {
          try {
            const accountNo = payload?.data?.state === 'ACCOUNT_INFO_EXISTS' ? payload.data.accountId || null : null;
            this.setAccountNo(accountNo);
          } catch (_error) {}
        },
      });
    } catch (_error) {}
  }
}
